// @flow

import React, {PureComponent} from 'react';
import Details, {type ListingShape} from '../Details/Details';
import {Price, type PriceSummaryShape, type PriceShape} from '../Price/Price';
import Rating, {type ListingShape as RatingShape} from '../Rating/Rating';
import {triggerMultiUnitItemClickEDAPEvent} from '../../utils/hitEdapUtils';
import './MultiUnitItem.less';
import {Link} from '@homeaway/react-localization-components';

type OwnProps = {
    context: string, // can be either 'modal' or a 'dropdown'
    fullLocale: string,
    isDatelessSearch: boolean,
    isMetric: boolean,
    propertyId: number // TODO: is this needed? We don't use it directly but DO pass `this.props` directly to an EDAP trigger.
};

// TODO: define listing query fragment and listing shape here
// compose fragment using listing fragments from Price, Rating, etc.
type OtherListingProps = {
    averagePrice: PriceShape,
    detailPageUrl: string,
    listingId: string,
    mobileThumbnailUrl: string,
    priceSummary: PriceSummaryShape,
    totalPrice: PriceShape,
    unitName: string
};

export type MultiUnitItemShape = OwnProps &
    ListingShape &
    RatingShape &
    OtherListingProps;
export class MultiUnitItem extends PureComponent<MultiUnitItemShape> {
    static defaultProps = {
        starSize: 'sm'
    };

    renderMultiUnitItem = () => {
        const {
            bedrooms,
            sleeps,
            unitName,
            propertyType,
            bathrooms,
            spaces,
            averageRating,
            reviewCount,
            mobileThumbnailUrl,
            detailPageUrl,
            isMetric,
            isDatelessSearch,
            fullLocale,
            petsAllowed,
            starSize,
            context
        } = this.props;

        const detailsListing = {
            bathrooms,
            bedrooms,
            sleeps,
            propertyType,
            spaces,
            petsAllowed
        };

        const rateListing = {
            averageRating,
            reviewCount,
            starSize
        };

        const sendEdapDetails = {
            onClick: () => triggerMultiUnitItemClickEDAPEvent(this.props)
        };

        return (
            <li className={`MultiUnitItem MultiUnitItem--${context}`}>
                <Link
                    className="MultiUnitItem__link"
                    href={detailPageUrl}
                    {...sendEdapDetails}
                    target={'_blank'}
                >
                    <div className="MultiUnitItemImage">
                        <div
                            className="MultiUnitItemImage__image-div"
                            style={{
                                backgroundImage: `url(${mobileThumbnailUrl})`
                            }}
                        />
                    </div>
                    <div className="MultiUnitItem__content">
                        <div className="MultiUnitItem__content-row MultiUnitItem__content-row--title micro">
                            <strong className="MultiUnitItem__truncated-content">
                                {unitName || ' '}
                            </strong>
                        </div>
                        <div className="MultiUnitItem__content-row MultiUnitItem__content-row--details MultiUnitItem__truncated-content micro">
                            <Details
                                listing={detailsListing}
                                isMetric={isMetric}
                                propertyType={propertyType}
                            />
                        </div>
                        <div className="MultiUnitItem__content-row MultiUnitItem__content-row--price-ratings">
                            <Price
                                listing={this.props}
                                useAverageLabel={isDatelessSearch}
                                fullLocale={fullLocale}
                            />
                            <span className="Reviews">
                                <Rating listing={rateListing} />
                            </span>
                        </div>
                    </div>
                </Link>
            </li>
        );
    };

    render() {
        return this.renderMultiUnitItem();
    }
}
